import { map, tap } from "rxjs/operators";
import { GET, POST } from "../../../module/services/fetch";
import { IRequestModel } from "./models";
import {
  SecurityQuestionBody,
  UigpOtpBody,
} from "../../../common/TwoFactorAuth/module/constants";

export const fetchUserRequest = () =>
  GET(`user/accounts`).pipe(map((response: any) => response));

export const forcedChangePwsService = (body: {
  accountId: string;
  identitySystemId: string;
  password: string;
  otp: string;
}) =>
  POST("user/changePwd", body).pipe(
    tap({
      next: (response: any) => {
        console.log("[user/changePwd] Response:", response);
      },
      error: (error: any) => {
        console.error(
          "[user/changePwd] Error:",
          error?.response?.data ?? error
        );
      },
    }),
    map((response: any) => response)
  );

export const verifyArcotChangeService = (body: IRequestModel) =>
  POST("user/changePassword", body).pipe(
    tap({
      next: (response: any) => {
        console.log("[user/changePassword - Arcot] Response:", response);
      },
      error: (error: any) => {
        console.error(
          "[user/changePassword - Arcot] Error:",
          error?.response?.data ?? error
        );
      },
    }),
    map((response: any) => response)
  );

export const fetchPasswordPolicy = (body: {
  accountId: string;
  identitySystemId: string;
}) => {
  const { accountId, identitySystemId } = body;

  return GET(
    `user/account/passwordPolicy?accountId=${accountId}&identitySystemId=${identitySystemId}`
  ).pipe(map((response: any) => response));
};

export const fetchGetSecurityQuestionsChange = () =>
  GET(`authentication/question?operation=CHG_PWD`).pipe(
    map((response: any) => response)
  );

export const fetchVerifyQuestions = (body: any[]) =>
  POST("authentication/question/verify", body).pipe(
    map((response: any) => response)
  );

export const fetchChangePassword = (body: any[]) =>
  POST("user/changePassword", body).pipe(
    tap({
      next: (response: any) => {
        console.log("[user/changePassword] Response:", response);
      },
      error: (error: any) => {
        console.error(
          "[user/changePassword] Error:",
          error?.response?.data ?? error
        );
      },
    }),
    map((response: any) => response)
  );

export const verifySecurityQuestionsChangeService = (
  body: SecurityQuestionBody
) => {
  return POST(`authentication/question/verify/change-pwd`, body).pipe(
    tap({
      next: (response: any) => {
        console.log(
          "[authentication/question/verify/change-pwd] Response:",
          response
        );
      },
      error: (error: any) => {
        console.error(
          "[authentication/question/verify/change-pwd] Error:",
          error?.response?.data ?? error
        );
      },
    }),
    map((response: any) => response)
  );
};

export const verifyUigpOtpChangeService = (body: UigpOtpBody) => {
  return POST(`authentication/validate-chg-pwd`, body).pipe(
    tap({
      next: (response: any) => {
        console.log(
          "[authentication/validate-chg-pwd] Response:",
          response
        );
      },
      error: (error: any) => {
        console.error(
          "[authentication/validate-chg-pwd] Error:",
          error?.response?.data ?? error
        );
      },
    }),
    map((response: any) => response)
  );
};
